/**
 * @generated SignedSource<<33828c199e4879ce056870fc8c28e9a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type InspectionMapQuery$variables = {
  userId?: string | null;
};
export type InspectionMapQuery$data = {
  readonly allInspectionfields: {
    readonly edgeCount: number | null;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly field: {
          readonly geometry: any | null;
        } | null;
        readonly id: string;
        readonly managementPackageVariant: {
          readonly code: string;
        } | null;
        readonly member: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly plannedDate: any | null;
        readonly state: InspectionfieldStateEnum | null;
        readonly year: number;
      } | null;
    } | null>;
    readonly totalCount: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"MapListViewFragment">;
  } | null;
  readonly user: {
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly collective: {
            readonly boundingBox: ReadonlyArray<number | null> | null;
          };
        } | null;
      } | null>;
    };
  } | null;
};
export type InspectionMapQuery = {
  response: InspectionMapQuery$data;
  variables: InspectionMapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boundingBox",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "inspector_Isnull",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "inspector_User",
    "variableName": "userId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edgeCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "geometry",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionMapQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAppPermissionNodeConnection",
            "kind": "LinkedField",
            "name": "roles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAppPermissionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAppPermissionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CollectiveNode",
                        "kind": "LinkedField",
                        "name": "collective",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "InspectionfieldNodeConnection",
        "kind": "LinkedField",
        "name": "allInspectionfields",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MapListViewFragment"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberNode",
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectNode",
                    "kind": "LinkedField",
                    "name": "managementPackageVariant",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldNode",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionMapQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAppPermissionNodeConnection",
            "kind": "LinkedField",
            "name": "roles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAppPermissionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAppPermissionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CollectiveNode",
                        "kind": "LinkedField",
                        "name": "collective",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "InspectionfieldNodeConnection",
        "kind": "LinkedField",
        "name": "allInspectionfields",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalId",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "periodStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "periodEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionNode",
                    "kind": "LinkedField",
                    "name": "latestInspection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastModified",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "approvedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "retryDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rejectedDate",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldNode",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previousId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ManagementPackageSettingsNode",
                    "kind": "LinkedField",
                    "name": "managementPackageSetting",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayNameAlt",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberNode",
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectNode",
                    "kind": "LinkedField",
                    "name": "managementPackageVariant",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e59a8b90c9fa09489f90e4a8f95911c",
    "id": null,
    "metadata": {},
    "name": "InspectionMapQuery",
    "operationKind": "query",
    "text": "query InspectionMapQuery(\n  $userId: ID\n) {\n  user {\n    roles {\n      edges {\n        node {\n          collective {\n            boundingBox\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  allInspectionfields(inspector_Isnull: false, inspector_User: $userId) {\n    totalCount\n    edgeCount\n    ...MapListViewFragment\n    edges {\n      node {\n        state\n        id\n        member {\n          id\n          name\n        }\n        year\n        plannedDate\n        managementPackageVariant {\n          code\n          id\n        }\n        field {\n          geometry\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment InspectionFieldCard on InspectionfieldNode {\n  id\n  externalId\n  state\n  year\n  periodStart\n  periodEnd\n  assignedDate\n  plannedDate\n  latestInspection {\n    retryDate\n    approvedDate\n    rejectedDate\n    lastModified\n    id\n  }\n  managementPackageSetting {\n    displayNameAlt\n    id\n  }\n  member {\n    name\n    id\n  }\n  field {\n    id\n    previousId\n  }\n}\n\nfragment MapListViewFragment on InspectionfieldNodeConnection {\n  totalCount\n  edges {\n    node {\n      id\n      year\n      externalId\n      state\n      plannedDate\n      periodStart\n      periodEnd\n      latestInspection {\n        lastModified\n        approvedDate\n        retryDate\n        rejectedDate\n        id\n      }\n      field {\n        geometry\n        id\n      }\n      ...InspectionFieldCard\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d152695e943fcec076dd57a28ac95fd7";

export default node;
